import React from 'react';
import {ITranslate} from '../../../../../../services/LocalizationService';

type InteractionSummaryTitleProps = {
    translate: ITranslate;
};

export const InteractionSummaryTitle: React.FC<InteractionSummaryTitleProps> = ({translate}) => (
    <div className='gallery-collapsible__title use-common-styles'>
        <span>{translate('REACT.INTERACTION.SUMMARY.INTERACTION.SUMMARY')}</span>
        <span className='collapsible-widget-arrow-container'></span>
    </div>
);
